import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericNameFilter } from './GenericNameFilter';

export function CourseNameFilter(): ReactElement {
  const { t } = useTranslation();

  return <GenericNameFilter label={t('CourseName')} placeholder={t('SearchCourseName')} />;
}
